export const FETCH_USER_LIST_JOBS_SUCCESS = "FETCH_USER_LIST_JOBS_SUCCESS"
export const FETCH_USER_LIST_JOBS_FAIL = "FETCH_USER_LIST_JOBS_FAIL"

export const FETCH__HISTORY__JOBS__SUCCESS ="FETCH__HISTORY__JOBS__SUCCESS"
export const FETCH__HISTORY__JOBS__FAIL ="FETCH__HISTORY__JOBS__FAIL;"

export const FETCH__UPLOAD__SUCCESS ="FETCH__UPLOAD__SUCCESS"
export const FETCH__UPLOAD__FAIL ="FETCH__UPLOAD__FAIL"